import store from "@/store";
import Auth from "@/views/Auth/index";
import RouterView from "@/views/Layout/RouterView.vue";
import Layout from "@/views/Layout/index";
import RedirectToFirst from "@/views/RedirectToFirst";
import Vue from "vue";
import Router from "vue-router";
import writingIcon from "./images/writing.png";

Vue.use(Router);
export const constantRoutes = [
  {
    path: "examinerCourse",
    name: "Course",
    iconImg: require("./images/class.png"),
    component: RouterView,
    permission: "10",
    children: [
      {
        path: "examinerCourseList",
        name: "My Class",
        component: () => import("@/views/examinerCourse/examinerCourseList")
      }
    ]
  },
  {
    path: "course",
    name: "在线课程",
    iconImg: require("./images/class.png"),
    component: RouterView,
    permission: "3",
    children: [
      {
        path: "courseList",
        name: "我的课表",
        component: () => import("@/views/course/courseList")
      }
      // {
      //   path: "myCourse",
      //   name: "我的课程",
      //   component: () => import("@/views/course/myCourse")
      // },
      // {
      //   path: "courseware",
      //   name: "我的课件",
      //   component: () => import("@/views/course/courseware")
      // }
    ]
  },
  {
    path: "writingCorrection",
    name: "写作批改",
    component: RouterView,
    iconImg: writingIcon,
    permission: "1",
    children: [
      {
        path: "home",
        name: "批改首页",
        component: () => import("@/views/writingCorrection/home")
      },
      {
        path: "answerQuestionRecord",
        name: "答疑记录",
        component: () =>
          import("@/views/writingCorrection/answerQuestionRecord")
      }
    ]
  },
  {
    path: "oralPartnerTraining",
    name: "口语陪练",
    iconImg: require("./images/oral.png"),
    component: RouterView,
    permission: "2",
    firstChildIndex: ({ isTeacher }) => (isTeacher ? 1 : 0),
    children: [
      {
        path: "studentManage",
        name: "口语学员管理",
        rolePermission: ({ isDistributor }) => !!isDistributor,
        component: () => import("@/views/oralPartnerTraining/studentManage")
      },
      {
        path: "arrangeClassRecord",
        name: "约课记录",
        component: () =>
          import("@/views/oralPartnerTraining/arrangeClassRecord")
      },
      {
        path: "teacherSchedule",
        name: "教师课表",
        rolePermission: ({ isDistributor }) => !!isDistributor,
        component: () => import("@/views/oralPartnerTraining/teacherSchedule")
      }
    ]
  },
  {
    path: "chineseTeacher1V1",
    name: "中教1V1",
    iconImg: require("./images/chinese_teacher_1v1.png"),
    component: RouterView,
    permission: "9",
    children: [
      {
        path: "classAppointmentRecord",
        name: "约课记录",
        component: () =>
          import("@/views/chineseTeacher1V1/classAppointmentRecord")
      },
      {
        path: "teacherSchedule",
        name: "教师课表",
        component: () => import("@/views/chineseTeacher1V1/teacherSchedule")
      },
      {
        path: "waitingClass",
        name: "待上课程",
        component: () => import("@/views/chineseTeacher1V1/waitingClass")
      },
      {
        path: "courseReplay",
        name: "课程回放",
        rolePermission: ({ isDistributor }) => !!isDistributor,
        component: () => import("@/views/chineseTeacher1V1/courseReplay")
      }
    ]
  },
  {
    path: "oralComment",
    name: () => "MENU.OC",
    iconImg: require("./images/oral_comment.png"),
    component: RouterView,
    permission: "5",
    children: [
      {
        path: "home",
        name: () => "MENU.OCHome",
        component: () => import("@/views/oralComment/home")
      },
      {
        path: "rule",
        name: () => "MENU.RUlE",
        rolePermission: ({ isDistributor }) => !!isDistributor,
        component: () => import("@/views/oralComment/rule")
      }
    ]
  },
  {
    path: "accountManage",
    name: "账号管理",
    iconImg: require("./images/person.png"),
    component: RouterView,
    permission: "6",
    children: [
      {
        path: "teacher",
        name: "教师管理",
        component: () => import("@/views/accountManage/teacher")
      },
      {
        path: "sonAccount",
        name: "子账号管理",
        permission: "7",
        component: () => import("@/views/accountManage/sonAccount")
      }
    ]
  },
  {
    path: "personalCenter",
    name: "个人中心",
    iconImg: require("./images/person.png"),
    component: RouterView,
    permission: "4",
    children: [
      {
        path: "myAccount",
        name: "我的账单",
        component: () => import("@/views/personalCenter/myAccount")
      }
      // ,{
      //   path: 'tradeRecord',
      //   name: '交易记录',
      //   component: () => import('@/views/personalCenter/tradeRecord')
      //  }
    ]
  }
];
const subRoutes = [
  {
    name: "teacherDetail",
    path: "personalCenter/myAccount/teacherDetail/:billCode/:teacherName", // 教师明细
    component: () => import("@/views/personalCenter/myAccount/teacherDetail")
  },
  {
    name: "distributorDetail",
    path:
      "personalCenter/myAccount/distributorDetail/:distributorBillId/:distributorName/:billCode", // 机构明细
    component: () =>
      import("@/views/personalCenter/myAccount/distributorDetail")
  },
  {
    path: "oralComment/commentDetail/:id", // 口语点评详情
    component: () => import("@/views/oralComment/commentDetail")
  },
  {
    path: "writingCorrection/home/correctComposition/:id", // 批改>立即批改
    component: () => import("@/views/writingCorrection/correctComposition")
  },
  {
    path: "writingCorrection/answerQuestionRecord/correctComposition/:id", // 批改>答疑
    component: () => import("@/views/writingCorrection/correctComposition")
  },
  {
    path: "chineseTeacher1V1/teacherSchedule/:id",
    component: () =>
      import(
        "@/views/chineseTeacher1V1/teacherSchedule/components/TeacherSchedule"
      )
  }
];
const VueRouter = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      component: Auth,
      children: [
        {
          path: "",
          redirect: "/redirect", // '/'根路径跳转到重定向页
          component: Layout,
          children: [
            {
              path: "/course/myCourse/catalogue",
              name: "课程目录",
              component: () => import("@/views/course/myCourse/catalogue")
            },
            {
              path: "/course/myCourse/student",
              name: "学员列表",
              component: () => import("@/views/course/myCourse/student")
            },
            ...subRoutes,
            ...constantRoutes
          ]
        },
        {
          path: "redirect",
          component: RedirectToFirst
        }
      ]
    },
    {
      path: "/login",
      component: () => import("@/views/login/index.vue")
    },
    {
      path: "/livePage/:lessonId/:lessonType/:supplierType",
      component: () => import("@/views/livePage/index")
    },
    {
      path: "*",
      redirect: "/"
    }
  ]
});
VueRouter.beforeEach((to, from, next) => {
  let show = !!to.path.includes("oralComment");
  store.commit("language/languageSelector", show);
  if (!show) {
    store.commit("language/UPDATE_LOCALE_LANGUAGE", "zh-CN");
  }
  next();
});
export default VueRouter;



// WEBPACK FOOTER //
// ./src/router/index.js